import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { withContent } from 'components/Content';
import Button from 'components/ContentfulFields/Button';

import styles from './clientele.scss';

const CONTENT_KEYS = {
  title: 'Title',
  offices: 'Features',
  cta: 'Who We Serve',
};

const Clientele = ({ content }) => (
  <div className={styles.clientele}>
    <h2 className={styles.title}>{content.title}</h2>
    <div className={styles.offices}>
      {content.offices.fields.features.map((feature) => {
        const { description, title, images } = feature.fields;
        return (
          <div key={feature.sys.id} className={styles.office}>
            <div className={styles.imgWrapper}>
              <img
                src={`${images[0].fields.file.url}?fm=webp`}
                alt={images[0].fields.title}
              />
            </div>
            <h3
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: title }}
            ></h3>
            {documentToReactComponents(description)}
          </div>
        );
      })}
    </div>
    <Button className={styles.cta} document={content.cta} />
  </div>
);

export default withContent(CONTENT_KEYS)(Clientele);
